// @flow
import React from 'react';
import { escapeForUrl } from 'lib/common';
import { Link } from 'react-router-dom';
import './LetterTags.scss';

type Props = {
  tags: string[],
};

const LetterTags = ({ tags }: Props) => (
  <div className="LetterTags">
    {tags.map(t => (
      <Link to={`/tags/${escapeForUrl(t)}`} key={t}>
        {t}
      </Link>
    ))}
  </div>
);

export default LetterTags;



// WEBPACK FOOTER //
// ./src/components/letter/LetterTags/LetterTags.js